module.exports = __webpack_public_path__ + "ded4f17c5a296f890957eec68a6ee665.png";